import * as Types from '../types';
import { Environment } from '../../../config';
import request from '../../../utils/request';

export interface FetchPaymentsReceivedListInput {
  sortField: string;
  page: number;
  pageSize: number;
  order: 'asc' | 'desc';
  vat_num?: string;
  originatingCountry?: string;
  schemeType?: string;
}

export interface PaymentsReceivedListElement {
  applicant_id: number;
  vat_number: string;
  is_sent: boolean;
  type: string;
  reminded_date: Date;
}

export interface PaymentsReceivedListData {
  paging: PaymentsReceivedListPaging;
  items: PaymentsReceivedListElement[];
}

export interface PaymentsReceivedListPaging {
  page: number;
  pageSize: number;
  total: number;
}

export const fetchPaymentsReceivedList = async (
  payload: FetchPaymentsReceivedListInput
): Promise<Types.ResponseOutput> => {
  let searchQuery = '';
  if (payload.vat_num) searchQuery += `&vat_num=${payload.vat_num}`;
  if (payload.originatingCountry)
    searchQuery += `&originatingCountry=${payload.originatingCountry}`;
  if (payload.schemeType) searchQuery += `&schemeType=${payload.schemeType}`;
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/payment-received/list?page=${payload.page}&pageSize=${payload.pageSize}&sortField=${payload.sortField}&order=${payload.order}${searchQuery}`
  );

  let _data: PaymentsReceivedListData = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

export const allocateReceivedPayment = async (payload: {
  paymentReceivedId: number;
}): Promise<Types.ResponseOutput> => {
  const data: any = await request(
    'post',
    `${Environment.API_BASE_URL}/api/payment-received/allocate`,
    {
      paymentReceivedId: payload.paymentReceivedId,
    }
  );
  let output: Types.ResponseOutput = {
    message: data.message,
    data: data.data,
    status: data.status,
  };
  return output;
};
